module.exports = __webpack_public_path__ + "img/toplogo.92c564ee.png";